import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H1 } from 'foundations-components/transitional/components/H1';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { extractEmbedParametersFromAcademyUrl } from 'embedded-academy-lib';
import { useState } from 'react';
import { useUserInfo } from '../../accounts/accountsQueries';
import { useFullLesson } from '../../lessons/lessonQueries';
import { useShort } from '../../shortContent/shortContentQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { getIsHubSpotter } from '../../../utils/hubspotterUtils';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import IFrameEmbedView from './IFrameEmbedView';
import { useEmbedState } from '../embedStore';
import ReactEmbedView from './ReactEmbedView';
import { CodeIcon } from 'foundations-assets/icons/components/CodeIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CopyEmbedCodeModal = ({
  onClose,
  title,
  lessonId,
  contentId,
  shortId,
  language
}) => {
  const {
    selectedTabId,
    setSelectedTabId
  } = useEmbedState();
  const handleSelectionChange = event => {
    setSelectedTabId(String(event.target.value));
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 800,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.title",
          options: {
            contentName: title
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      marginBlockStart: "400",
      style: {
        textAlign: 'unset'
      },
      children: /*#__PURE__*/_jsxs(Tabs, {
        marginBlockEnd: "200",
        onSelectedChange: handleSelectionChange,
        selected: selectedTabId,
        children: [/*#__PURE__*/_jsx(Tab, {
          tabId: "iframe",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.tabs.iframe"
          }),
          children: /*#__PURE__*/_jsx(IFrameEmbedView, {
            contentId: contentId,
            language: language,
            lessonId: lessonId,
            shortId: shortId
          })
        }), /*#__PURE__*/_jsx(Tab, {
          tabId: "react",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.tabs.react"
          }),
          children: /*#__PURE__*/_jsx(ReactEmbedView, {
            contentId: contentId,
            language: language,
            lessonId: lessonId,
            shortId: shortId
          })
        })]
      })
    })]
  });
};
const CopyEmbedCodeMenuOption = ({
  language
}) => {
  const {
    userInfo
  } = useUserInfo();
  const isHubspotter = getIsHubSpotter(userInfo);
  const [isOpen, setIsOpen] = useState(false);
  const {
    lessonId,
    contentId,
    shortId
  } = extractEmbedParametersFromAcademyUrl(window.location.toString());
  const {
    lesson
  } = useFullLesson(lessonId, undefined, !lessonId);
  const {
    short
  } = useShort(shortId, !shortId);
  const lessonVideoContent = lesson === null || lesson === void 0 ? void 0 : lesson.content.find(content => content.id === contentId && content.contentType === 'VIDEO');
  if (!(lessonId && contentId || shortId) ||
  // has valid embed parameters
  !isHubspotter || lesson && !lessonVideoContent // only videos can be embedded
  ) {
    return null;
  }
  const isEmbeddable = lesson && lesson.visibility === 'PUBLIC' || short && short.visibility === 'PUBLIC';
  return /*#__PURE__*/_jsx(Tooltip, {
    title: !isEmbeddable ? I18n.text('learningCenter.embedModal.notEmbeddableTooltip') : undefined,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        block: true,
        disabled: !isEmbeddable,
        onClick: () => setIsOpen(true),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(SideNavItem, {
            disabled: !isEmbeddable,
            role: "navigation-item",
            title: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(IconHolder, {
                icon: CodeIcon,
                marginInlineStart: "-200"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.cardMenu.copyEmbedCode"
              })]
            })
          })
        })
      }), isOpen && /*#__PURE__*/_jsx(CopyEmbedCodeModal, {
        contentId: contentId,
        language: language,
        lessonId: lessonId,
        onClose: () => setIsOpen(false),
        shortId: shortId,
        title: (lessonVideoContent === null || lessonVideoContent === void 0 ? void 0 : lessonVideoContent.name) || (short === null || short === void 0 ? void 0 : short.name) || ''
      })]
    })
  });
};
export default CopyEmbedCodeMenuOption;